import React from "react";
import "./ContactForm.css";

function ContactForm() {
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "1ccd6bb0-dff0-43f5-9d74-6e52ad866d5b");

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    }).then((res) => res.json());

    if (res.success) {
      console.log("Success", res);
      setResult(res.message);
    } else {
      console.log("Error", res);
      setResult(res.message);
    }
  };

  return (
    <div className="contact-left">
      <div className="contact-left-title">
        <h2>Contact us for a free quote</h2>
      </div>
      <form onSubmit={onSubmit}>
        <div>
          <input
            className="contact-inputs"
            type="text"
            name="name"
            placeholder="Your Name"
            required
          />
        </div>
        <div>
          <input
            className="contact-inputs"
            type="email"
            name="email"
            placeholder="Your Email"
            required
          />
        </div>
        <div>
          <textarea
            className="contact-inputs"
            name="message"
            placeholder="Enter text here ..."
            required
          ></textarea>
        </div>
        <div>
          <button type="submit"> Send a message</button>
        </div>
      </form>
      <span>{result}</span>
    </div>
  );
}

export default ContactForm;
